<template>
  <div class="sheet-vehicle-feature-header-component">
    <div class="heading">{{ title }}</div>
    <div class="divider" v-if="hasVehiclePicker"></div>
    <VehiclePickerMenu v-if="hasVehiclePicker" />
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.sheet-vehicle-feature-header-component {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .heading {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 1.1875rem;
    color: $brand-color-1;
    margin-right: 3px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .divider {
    width: 1px;
    min-width: 1px;
    height: 20px;
    background-color: $brand-color-1;
    margin: 0 10px;
    flex-shrink: 0;
  }

  /deep/ .menu__link {
    color: $brand-color-1;

    .selected-item {
      width: auto;
      max-width: 150px;
    }
  }

  /deep/ .menu-button .icon {
    fill: $brand-color-1;
  }
}
</style>

<script>
import VehiclePickerMenu from "@/components/screens/VehiclePickerMenu";

export default {
  name: "SheetVehicleFeatureHeader",
  components: {
    VehiclePickerMenu,
  },
  props: {
    title: {
      type: String,
    },
    hasVehiclePicker: {
      type: Boolean,
      default: true,
    },
  },
};
</script>